<template lang="pug">
    v-container(v-if="event")
      v-flex(xs12)
        v-card(color="white " flat light)
          v-layout( row wrap )
            v-flex.pa-3(xs12 sm4)
                v-img(
                  :src="imageSrc"
                  contain) 
            v-flex.pa-4(xs12 sm8)
              //v-card-title(primary-title)
              div
                div(class="title") {{event.eventName}}
                div.body-2 {{event.location}}
                div {{event.eventDate}}
                v-flex.py-3(style="white-space: pre-wrap")  {{event.description}}
                div.body-2 Pickup Time 
                  time-changer(:time="event.startTime")
                  span  - 
                  time-changer(:time="event.endTime")
      v-divider
      v-layout.py-3(row wrap v-if="event.packages")
       
        v-flex.display-1.py-3(xs12) Choose your package
        v-flex.pa-1(v-for="(item, key) in event.packages" xs12 sm6 md3)
          event-package(:epackage="item")
            
                      
                    
              
</template>
<script>
//Event page that shows the event + packages
import TimeChanger from '../components/TimeChanger'
import EventPackage from '../components/EventPackage'
export default {
  name:'Event',
  components:{EventPackage, TimeChanger},
  data:()=>({
  }),
  created(){
    //console.log("Route: "+this.$route.params.id)
    this.$store.dispatch('setSelectedEvent', this.$route.params.id)
  },
  computed:{
    imageSrc(){return this.$store.state.baseImageURL + this.event.imageURL+"?alt=media"},
    event(){
      return this.$store.state.events.find(el=>{return el.id == this.$route.params.id})
    },
    id(){
      return this.$route.params.id
    }
  }

}
</script>
<style scoped>

</style>